var map = {
	"./blocks/custom/headerImage/block.js": 20883,
	"./blocks/custom/iconGrid/block.js": 35432,
	"./blocks/custom/imageHighlightText/block.js": 58807,
	"./blocks/custom/imageLeftRightText/block.js": 55352,
	"./blocks/custom/imageRightLeftText/block.js": 61531,
	"./blocks/custom/instagramFeed/block.js": 70182,
	"./blocks/custom/latestNewsSwiper/block.js": 44830,
	"./blocks/custom/newsletter/block.js": 30330,
	"./blocks/custom/quote/block.js": 53278,
	"./blocks/custom/videoSlider/block.js": 22853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87688;